export default {
    driver_performance_events_info_name: "Event",
    driver_performance_events_info_category: "Category",
    driver_performance_events_info_no_case_info: "No Event information available.",
    driver_performance_events_info_risk: "Risk",
};